import React, {useState} from "react";
import {useDispatch} from "react-redux";
import { Animate} from "react-simple-animate";

import defaultSleepImage1 from '../../../assets/default-images/default-sleep-image-1.png';
import defaultSleepImage2 from '../../../assets/default-images/default-sleep-image-2.png';
import defaultSleepImage3 from '../../../assets/default-images/default-sleep-image-3.png';
import defaultSleepImage4 from '../../../assets/default-images/default-sleep-image-4.png';
import defaultSleepImage6 from '../../../assets/default-images/default-sleep-image-6.jpg';
import defaultSleepImage7 from '../../../assets/default-images/default-sleep-image-7.jpg';
import defaultSleepImage8 from '../../../assets/default-images/default-sleep-image-8.jpg';
import defaultSleepImage9 from '../../../assets/default-images/default-sleep-image-9.jpg';
import defaultSleepImage10 from '../../../assets/default-images/default-sleep-image-10.jpg';

import stripHtml from "../../Components/StripHTML";
import {setWatchOffCanvasIsActive, setReadOffCanvasIsActive, setLearnOffCanvasIsActive} from "../../../Features/Misc/navBarSlice";
import {setActiveWatch, setActiveRead, setActiveLearn} from "../../../Features/Misc/activeSlice";



export default function RecommendedCard(props) {
    const {
        imgSrc,
        title,
        text,
        vidLink,
        mediaType,
        mediaId,
        orientation,
        type,
        date,
        authorName
    } = props

    const payload = React.useMemo(() => ({
        imgSrc,
        title,
        text,
        vidLink,
        mediaType,
        mediaId,
        orientation,
        date,
        authorName
    }), [imgSrc, title, text, vidLink, mediaType, mediaId, orientation, authorName]);

    //fallback image
    const defaultImgChoice = [
        defaultSleepImage1,
        defaultSleepImage2,
        defaultSleepImage3,
        defaultSleepImage4,
        defaultSleepImage6,
        defaultSleepImage7,
        defaultSleepImage8,
        defaultSleepImage9,
        defaultSleepImage10,
    ];

    const randomImgNumber = Math.floor(Math.random() * 9);
    const imageUrl = imgSrc || defaultImgChoice[randomImgNumber];

    const dispatch = useDispatch()


    const handleWatchCardClick = React.useCallback(() => {
        dispatch(setWatchOffCanvasIsActive());
        dispatch(setActiveWatch(payload));
    }, [dispatch, payload]);

    const handleReadCardClick = React.useCallback(() => {
        dispatch(setReadOffCanvasIsActive());
        dispatch(setActiveRead(payload));
    }, [dispatch, payload]);

    const handleLearnCardClick = React.useCallback(() => {
        dispatch(setLearnOffCanvasIsActive());
        dispatch(setActiveLearn(payload));
    }, [dispatch, payload]);


    return (
        <>
            {type && type === "watch" && (
                <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                    <div onClick={handleWatchCardClick} className={`px-1 cursor-pointer hover:opacity-60 transition-opacity duration-300`}>
                        <div
                            className="w-full h-36 p-2 lg:p-4 rounded-lg justify-between mb-4 flex flex-col bg-cover no-repeat bg-center relative"
                            style={{ backgroundImage: `url(${imageUrl})` }}
                        >
                            {/* Dark overlay */}
                            <div
                                className="absolute inset-0 bg-black opacity-30 rounded-lg"
                            ></div>

                            {/* Content */}
                            <div className={`flex flex-row justify-between items-center z-10 relative`}>
                                <div className={`text-white`}></div>

                            </div>
                            <div className={`flex flex-row justify-between items-center z-10 relative`}>
                                {/*<div*/}
                                {/*    className={`min-h-10 min-w-12 bg-pink-dashboard text-white p-1 px-2 rounded-lg flex items-center justify-center`}*/}
                                {/*>*/}
                                    {/*<i className="ri-video-line text-2xl font-light"></i>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </Animate>
            )}



            {type && type === "read" && (
                <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                    <div onClick={handleReadCardClick} className={`px-1 cursor-pointer hover:opacity-60 transition-opacity duration-300`}>
                        <div className="bg-white h-36 rounded-lg mb-4 flex flex-row text-black relative">
                            <div className="h-full rounded-lg w-5/12 bg-cover no-repeat bg-center relative" style={{ backgroundImage: `url(${imageUrl})` }}>



                            </div>
                            <div className={`h-full w-7/12 pl-4 py-8 relative`}>
                                <div className="font-semibold text-black z-10">{title && stripHtml(title.substring(0, 50))}...</div>
                                <div className="text-black text-sm z-10"></div>
                            </div>
                            <div className="icon h-full w-2/12 flex items-center justify-center py-12 z-10">
                                <i className="ri-arrow-right-line text-gold-accent text-3xl"></i>
                            </div>
                        </div>
                    </div>
                </Animate>
            )}




            {type && type === "learn" && (
                <Animate play start={{ opacity: 0 }} end={{ opacity: 1 }} duration={0.7}>
                    <div onClick={handleLearnCardClick} className={`px-1 cursor-pointer hover:opacity-60 transition-opacity duration-300`}>
                        <div className="w-full bg-white h-36 rounded-t-lg rounded-b-md mb-4 flex flex-col pt-4 text-black justify-between relative">
                            <div className="font-semibold text-black mb-2 px-4 z-10">{title && title}</div>
                            <p className="text-black text-sm truncate px-4 z-10">{text && stripHtml(text).substring(0, 40)}...</p>
                            <div className="time flex flex-row items-center justify-between px-4 z-10">
                                <div className="time__block flex flex-row items-center">
                                    <i className="ri-lightbulb-line text-gold-accent text-2xl mr-2" />
                                    <p className={`text-sm`}>Watch now</p>
                                </div>
                                <i className="ri-arrow-right-line text-gold-accent text-2xl" />
                            </div>
                            <div className="bg-gold-accent h-1.5 w-full rounded-b-lg"></div>
                            {/* Dark overlay */}
                            {/*<div className="absolute inset-0 bg-black opacity-40 rounded-t-lg"></div>*/}
                        </div>
                    </div>
                </Animate>
            )}



        </>
    );
}